import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { withRouter, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { getDefaultPolicy } from "../../../store/policies/actions";
import languages from "../../../common/languages";

const PrivacyPolicyPublicPage = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  let { lang } = useParams();

  const { loadingDefaultPolicySuccess, defaultPolicy } = useSelector(
    (state) => state.Policies
  );

  document.title = `${t("Fields.Privacy Policy")} | ${t(
    process.env.REACT_APP_HEADING
  )}`;

  function createMarkup() {
    if (lang === "ar") return { __html: defaultPolicy?.arabicText };
    else return { __html: defaultPolicy?.text };
  }

  useEffect(() => {
    dispatch(getDefaultPolicy());
    if (!lang || !languages[lang]) lang = "en";
  }, []);

  return (
    <React.Fragment>
      <div className="container-fluid mt-3" dir={lang === "ar" ? "rtl" : "ltr"}>
        {loadingDefaultPolicySuccess && (
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="card">
                <div className="bg-soft-warning position-relative">
                  <div className="card-body p-5">
                    <div className="text-center">
                      <h3>{lang === "ar" ? "مرتاح" : "MRTAH"}</h3>
                      <h5>
                        {lang === "ar"
                          ? defaultPolicy?.arabicTitle
                          : defaultPolicy?.title}
                      </h5>
                    </div>
                  </div>
                  <div className="shape"></div>
                </div>
                <div className="card-body p-4">
                  <div className="d-flex">
                    <p dangerouslySetInnerHTML={createMarkup()}></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default withRouter(PrivacyPolicyPublicPage);
